import { render, staticRenderFns } from "./partnerShareholderGoodsAward.vue?vue&type=template&id=7015f014&scoped=true&"
import script from "./partnerShareholderGoodsAward.vue?vue&type=script&lang=js&"
export * from "./partnerShareholderGoodsAward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7015f014",
  null
  
)

export default component.exports